import styled from 'styled-components';
import { Progress as AntProgress } from 'antd';

export const Progress = styled(AntProgress)``;
